import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setSolutionPage } from '../redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useSolutionSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getSolutionSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website.solution_page.solution_section}`);
      console.log("🚀 ~ getSolutionSectionJson ~ data:", response);
      console.log("🚀 ~ getSolutionSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setSolutionPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Solution section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getSolutionSectionJson();
  }, [getSolutionSectionJson]);

  return {
    data,
    loading,
    error,
    getSolutionSectionJson,
    fetchOnMount,
    refetch: getSolutionSectionJson
  };
};

export default useSolutionSection;
